module.exports = __webpack_public_path__ + "img/logo.6a9304ce.jpeg";